module.exports = __webpack_public_path__ + "media/images/icons/circle-check-ad5ad9b9799759d9541458e25375d376.svg";